module.exports = __webpack_public_path__ + "../resources/images/noSelection-1b17e1809c7b60db3b9242e8a0ef469b.svg";